<template>
  <dialog-frame :title="$t('uncovered-energy-tariff-period-dialog.dialog.title').toString()"
                icon="warning_outline"
                color="warning"
                closable
                @close="close">
    <template v-slot:content>
      <span v-html="$t('uncovered-energy-tariff-period-dialog.text')"/>
    </template>

    <template v-slot:actions>
      <v-btn plain block
             color="error"
             class="font-weight-bold d-block"
             @click="close">
        {{ $t('app.go-back') }}
      </v-btn>
    </template>
  </dialog-frame>
</template>

<script>

import DialogFrame from "@/templates/dialogs/DialogFrame";
export default {
  name: 'UncoveredEnergyTariffPeriodDialog',

  components: {
    DialogFrame
  },

  methods: {
    close() {
      this.$root.bisadialog.toggle('uncoveredEnergyTariffPeriod', false)
    }
  }

};
</script>

